/* Feedback visual de add-to-cart (issue #220, fase 1)
 *
 * Con cart_type 'page' el botón de agregar al carrito hace submit nativo
 * (navegación completa a /cart) sin ninguna señal de progreso. En productos
 * TiB la app además procesa el diseño antes de enviar el formulario, lo que
 * alarga la espera. Este script muestra spinner + 'Añadiendo…' desde el clic.
 *
 * No usa el atributo `disabled`: deshabilitar el botón dentro del clic puede
 * cancelar el submit nativo en algunos navegadores y rompe el re-clic
 * programático de apps (TiB). El bloqueo de clics repetidos se hace con
 * pointer-events en CSS (ver extra_css_product_form.css).
 */
(function () {
  var ADDING_TEXT = 'Añadiendo…';
  // Si una app bloquea el submit silenciosamente, el botón no debe quedar
  // atorado en 'Añadiendo…' para siempre.
  var RESET_FALLBACK_MS = 30000;

  var state = {
    button: null,
    originalHtml: null,
    timer: null,
    loadingBarStarted: false
  };

  function startLoading(button) {
    if (state.button) {
      return;
    }

    state.button = button;
    state.originalHtml = button.innerHTML;
    button.classList.add('is-adding');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = '<span class="add-button__spinner" aria-hidden="true"></span>' + ADDING_TEXT;

    // Activa también la barra de carga global del theme (LoadingBar en theme.min.js).
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    state.loadingBarStarted = true;

    state.timer = setTimeout(reset, RESET_FALLBACK_MS);
  }

  function reset() {
    if (!state.button) {
      return;
    }

    clearTimeout(state.timer);
    state.button.classList.remove('is-adding');
    state.button.removeAttribute('aria-busy');
    state.button.innerHTML = state.originalHtml;

    if (state.loadingBarStarted) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }

    state.button = null;
    state.originalHtml = null;
    state.timer = null;
    state.loadingBarStarted = false;
  }

  // Fase de captura: corre ANTES que los handlers de apps sobre el botón.
  // TiB detiene la propagación del clic mientras procesa el diseño, así que
  // en fase de burbuja el spinner aparecía hasta el final (QA 11-jun-2026).
  // Si una app rechaza el add con validación propia, el fallback de 30s
  // regresa el botón a su estado original.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.product-form [data-action="add-to-cart"]');

    if (!button) {
      return;
    }

    // Ya hay un add-to-cart en curso: bloquea solo interacciones reales del
    // usuario (Enter con foco en el botón); los clics programáticos de apps
    // deben pasar.
    if (state.button) {
      if (event.isTrusted) {
        event.preventDefault();
      }
      return;
    }

    var formElement = button.closest('form');

    // Si la validación nativa va a fallar, el navegador mostrará el error y
    // no habrá submit: no hay que poner el botón en estado de carga.
    if (!formElement || !formElement.checkValidity()) {
      return;
    }

    startLoading(button);
  }, true);

  // Enter en un campo del formulario dispara submit sin pasar por click.
  document.addEventListener('submit', function (event) {
    var formElement = event.target;

    if (!formElement.classList || !formElement.classList.contains('product-form')) {
      return;
    }

    var button = formElement.querySelector('[data-action="add-to-cart"]');

    if (button) {
      startLoading(button);
    }
  });

  // Al volver del carrito, el bfcache restaura la página con el botón aún en
  // 'Añadiendo…': hay que regresarlo a su estado original.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      reset();
    }
  });
})();
